import React, { useState } from 'react';
import styles from './DropDown.module.scss';
import { DropDownIcon } from '../../assets/svg/DropDownIcon';
import clsx from 'clsx';

interface IDropDown {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

export const DropDown = ({title, children, defaultOpen = false}: IDropDown) => {
  const [isOpen, setIsOpen] = useState<boolean>(defaultOpen);

  const handleOpen = () => {
    setIsOpen(!isOpen);
  }

  return (
    <div className={styles.wrapper}>
      <button className={styles.button} onClick={handleOpen}><span className={styles.title}>{title}</span> <span className={clsx({[styles.icon]: true, [styles.active]: isOpen})}><DropDownIcon /></span> </button>
      {isOpen ? (
        <div className={styles.content}>
          {children}
        </div>
      ) : null}
    </div>
  )
}
